import { useCallback } from 'react';
import { bridge, isNil } from 'shared/src/utils';
import { useGoodsBasic } from '../../../../../queries/useGoodsBasic';

export const useLogClickGoodsDetailLoadMore = () => {
  const { data: goodsBasic } = useGoodsBasic();

  return useCallback(() => {
    if (isNil(goodsBasic)) return;

    bridge.logAnalyticsEvent({
      name: 'CLICK_GOODS_DETAIL_LOAD_MORE',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        GOODS_SNO: goodsBasic?.sno,
        MARKET_SNO: goodsBasic?.market.sno,
      },
    });
  }, [goodsBasic]);
};
